import { Link, NavLink, Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import { LocationSwitcher } from "./LocationSwitcher";
import { UniversalSearch } from "./UniversalSearch";
import { getCurrentUser, loginUrl, type AppUser } from "../lib/auth";

const navItems = [
  { to: "/", label: "Home", end: true },
  { to: "/review-queue", label: "Review Queue" },
  { to: "/upload", label: "Upload" },
  { to: "/holds", label: "On hold" },
  { to: "/processing", label: "Processing" },
  { to: "/imported", label: "Imported" },
  { to: "/rejected", label: "Rejected" },
];

export function Layout() {
  const [user, setUser] = useState<AppUser | null | undefined>(undefined);

  useEffect(() => {
    void getCurrentUser().then(setUser);
  }, []);

  if (user === undefined) {
    return (
      <div className="flex items-center justify-center h-full text-ink-soft text-sm">
        Loading…
      </div>
    );
  }

  if (user === null) {
    return (
      <div className="flex flex-col items-center justify-center h-full gap-6 bg-gradient-to-br from-slate-50 to-slate-100">
        <img src="/logo.svg" alt="SmartRx Entry" className="h-20" />
        <p className="text-ink-soft text-sm">Sign in with your Pharmacy Innovations account.</p>
        <a
          href={loginUrl()}
          className="px-5 py-2.5 bg-accent text-white rounded-lg text-sm font-medium hover:bg-accent-dark shadow-sm transition-colors"
        >
          Sign in with Microsoft
        </a>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full">
      <header className="flex items-center px-6 h-16 bg-gradient-to-br from-accent-darker to-accent-dark shadow-header sticky top-0 z-10">
        <img src="/logo-light.svg" alt="SmartRx Entry" className="h-10 brightness-110" />
        <nav className="flex ml-10 h-full">
          {navItems.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end}
              className={({ isActive }) =>
                `flex items-center px-4 h-full text-sm font-medium transition-colors border-b-2 ${
                  isActive
                    ? "text-white border-sky-500 bg-white/5"
                    : "text-white/70 border-transparent hover:text-white hover:bg-white/5"
                }`
              }
            >
              {it.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex-1 px-6"><UniversalSearch /></div>
        <LocationSwitcher />
        <Link to="/settings" className="ml-4 text-xs text-white/80 hover:text-white">
          {user.userDetails} · ⚙
        </Link>
      </header>
      <main className="flex-1 overflow-auto bg-slate-50">
        <Outlet />
      </main>
    </div>
  );
}
